import { useMemo } from 'react';
import useSWR from 'swr';
import { fetcher } from './useSWR';
import {
  parseHiddenMenuHrefs,
  MENU_HIDDEN_HREFS_SETTING_KEY,
  DEFAULT_MENU_HIDDEN_HREFS,
} from '../config/menuHiddenRoutes';

function mergeHiddenMenuHrefs(settingValue) {
  const fromSetting = parseHiddenMenuHrefs(settingValue ?? '[]');
  return [...new Set([...DEFAULT_MENU_HIDDEN_HREFS, ...fromSetting])];
}

/**
 * @param {string} key — ApplicationSetting.key
 */
export function useApplicationSetting(key) {
  // Relative path — global `fetcher` prepends API_BASE_URL (do not pass full URL).
  const url = key ? `/application-setting/key/${encodeURIComponent(key)}` : null;
  const { data, error, isLoading, mutate } = useSWR(url, fetcher, {
    revalidateOnFocus: true,
  });
  return {
    setting: data ?? null,
    value: data?.value ?? null,
    isLoading,
    error,
    mutate,
  };
}

export function useHiddenMenuHrefs() {
  const { value, isLoading, mutate, error } = useApplicationSetting(MENU_HIDDEN_HREFS_SETTING_KEY);
  const hiddenHrefs = useMemo(() => mergeHiddenMenuHrefs(value), [value]);
  return { hiddenHrefs, isLoading, mutate, error };
}
